/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type TrackCard_cardInfo$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BrandsCards_brandsInfo$ref: FragmentReference;
export type BrandsCards_brandsInfo = $ReadOnlyArray<{|
  +id: string,
  +$fragmentRefs: TrackCard_cardInfo$ref,
  +$refType: BrandsCards_brandsInfo$ref,
|}>;
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BrandsCards_brandsInfo",
  "type": "Taxon",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TrackCard_cardInfo",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5b8aa4e9f0b39a6c69826707c6685cb0';
module.exports = node;
